export const MODULE_KEYS = {
    dashboard: "expense.dashboard",
    // Users / Groups / Permissions are emitted by the permissions service under
    // the `expense.*` domain (confirmed against the live payload), not `platform.*`.
    users: "expense.users",
    groups: "expense.groups",
    permissions: "expense.permissions",
    policyExceptions: "expense.policy.exceptions",
    // Mileage / currency / hotel are UI-only placeholders (disabled features);
    // they are not part of the CAS module catalog.
    policyMileage: "expense.policy.mileage",
    policyCurrency: "expense.policy.currency",
    policyHotel: "expense.policy.hotel",
    policyReceipt: "expense.policy.receipt",
    manageApprovals: "expense.manage.approvals",
    manageCategories: "expense.manage.categories",
    manageCustomData: "expense.manage.custom.data",
    utilities: "expense.utilities",
} as const;

const createActionSet = <T extends string>(moduleKey: T) => ({
    read: `${moduleKey}:read`,
    write: `${moduleKey}:write`,
});

export const ACTIONS = {
    dashboard: createActionSet(MODULE_KEYS.dashboard),
    users: createActionSet(MODULE_KEYS.users),
    groups: createActionSet(MODULE_KEYS.groups),
    permissions: createActionSet(MODULE_KEYS.permissions),
    policy: {
        exceptions: createActionSet(MODULE_KEYS.policyExceptions),
        mileage: createActionSet(MODULE_KEYS.policyMileage),
        currency: createActionSet(MODULE_KEYS.policyCurrency),
        hotel: createActionSet(MODULE_KEYS.policyHotel),
        receipt: createActionSet(MODULE_KEYS.policyReceipt),
    },
    manage: {
        approvals: createActionSet(MODULE_KEYS.manageApprovals),
        categories: createActionSet(MODULE_KEYS.manageCategories),
        customData: createActionSet(MODULE_KEYS.manageCustomData),
    },
    utilities: createActionSet(MODULE_KEYS.utilities),
} as const;

export const ALL_ACTION_KEYS = [
    ACTIONS.dashboard.read,
    ACTIONS.dashboard.write,
    ACTIONS.users.read,
    ACTIONS.users.write,
    ACTIONS.groups.read,
    ACTIONS.groups.write,
    ACTIONS.permissions.read,
    ACTIONS.permissions.write,
    ACTIONS.policy.exceptions.read,
    ACTIONS.policy.exceptions.write,
    ACTIONS.policy.mileage.read,
    ACTIONS.policy.mileage.write,
    ACTIONS.policy.currency.read,
    ACTIONS.policy.currency.write,
    ACTIONS.policy.hotel.read,
    ACTIONS.policy.hotel.write,
    ACTIONS.policy.receipt.read,
    ACTIONS.policy.receipt.write,
    ACTIONS.manage.approvals.read,
    ACTIONS.manage.approvals.write,
    ACTIONS.manage.categories.read,
    ACTIONS.manage.categories.write,
    ACTIONS.manage.customData.read,
    ACTIONS.manage.customData.write,
    ACTIONS.utilities.read,
    ACTIONS.utilities.write,
] as const;

export type ActionKey = (typeof ALL_ACTION_KEYS)[number];
